import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import NotifList from '../Modal/NotifList'

import './Header.css';
import Backon from '../Icons/Backon.svg';
import Pig from '../Icons/Pig.svg';
import Logout from '../Icons/Logout.svg';
import Notif from '../Icons/Notif.svg';


class Header extends Component {

  constructor() {
    super();

    this.handleClick = this.handleClick.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);

    this.state = {
      notifVisible: false
    };
  }

  componentDidMount(){
    this.props.actions.getProfile();
    this.props.actions.checkForNotifications();
  }

  handleClick() {
    this.props.actions.checkForNotifications();
    if (!this.state.notifVisible) {
      // attach/remove event handler
      document.addEventListener('click', this.handleOutsideClick, false);
    } else {
      document.removeEventListener('click', this.handleOutsideClick, false);
    }

    this.setState(prevState => ({
       notifVisible: !prevState.notifVisible,
    }));
  }

  logout() {
    this.props.logOut();
  }
  
  handleOutsideClick(e) {
    // ignore clicks on the component itself
    if (this.node.contains(e.target)) {
      return;
    }
    
    this.handleClick();
  }

  render() {
    return (
      <header>
        <div className="container header">
          <Link to='/'>
          	<div className="nav-illu">
        	  	<div className="nav-pig">
        	    	<img src={Pig} alt="Logo Pig" />
        	  	</div>
        	  	<div className="nav-backon">
        	    	<img src={Backon} alt="Logo Backon" />
        	  	</div>
          	</div>
          </Link>
          <div className="nav-bloc">
            <nav>
              <ul>
                <li className={ this.props.currentRoute === 'Explore' ? 'current' : ''}><Link to='/'>Explore</Link></li>
                <li className={ this.props.currentRoute === 'How it works' ? 'current' : ''}><Link to='/howitworks'>How it works</Link></li>
                <li className={ this.props.currentRoute === 'Your projects' ? 'current' : ''}><Link to='/yourprojects'>Your projects</Link></li>
                { this.props.isAdmin && <li className={ this.props.currentRoute === 'Admin' ? 'current' : ''}><Link to='/admin'>Admin</Link></li> }
              </ul>
            </nav>
            <div className="account">
              <Link to='/yourprojects'>
                <div className="avatar">
                  {this.props.currentUser.avatar &&
                    <img src={this.props.currentUser.avatar} alt="avatar" />
                  }
                </div>
              </Link>
            </div>
            {this.props.currentUserProjectsNotSeen.length > 0 &&
              <div className="notifications" ref={node => { this.node = node; }}>
                <div className={"icon " + (this.state.notifVisible && "active")} onClick={this.handleClick}>
                  <img src={Notif} alt="Notifications" className="notifIcon" />
                  <div className="counter">{this.props.currentUserProjectsNotSeen.length}</div>
                </div>
                {this.state.notifVisible &&
                  <div className="notifications-list"><NotifList projects={this.props.currentUserProjectsNotSeen} handleClick={this.handleClick}/></div>
                }
              </div>
            }
          </div>
        </div>
        <div onClick={this.logout.bind(this)}>
          <span className="logout-button">
            <img src={Logout} alt="log out" />
          </span>
        </div>
      </header>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/Header.js